<template>
  <div class="container">
    <div class="boxtop">
      <van-nav-bar
        title="课程详情"
        class="fixedtop"
        left-arrow
        @click-left="goBackFn"
      />
    </div>
    <div class="top__details">
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
        @ready="playerReadied"
        @play="onPlayerPlay($event)"
        @pause="onplayerPause($event)"
        @timeupdate="onPlayerTimeupdate($event)"
      >
      </video-player>
      <div class="contest">
        <div class="title__bxs">
          <div class="detail__title t_text">
            {{ introduces.name }}
          </div>
          <div class="detai_down">
            <div class="ont_b">{{ introduces.class_hour }}课时</div>
            <div class="ont_b ont_a">课程时长：{{ introduces.min }}分钟</div>
            <div class="ont_b">
              截止日期：{{ introduces.expirationtime_mobile }}
            </div>
          </div>
        </div>
        <!-- 内容管理 -->
        <div class="cont_title" id="second">
          <p class="contjs">课程详情</p>
          <div class="listContent" v-html="content"></div>
        </div>
      </div>
      <!-- 报名缴费入口已禁用 -->
      <div class="but__ton" v-if="false">
        <div class="butt_ox">
          <button
            class="jin_button"
            @click.stop="addPlan"
            :disabled="isDisable"
            v-if="is_join == 1"
          >
            加入学习计划
          </button>
          <button class="jin_button jin_color" v-else>已加入</button>
        </div>
      </div>
    </div>

    <!-- 资料未完善弹窗 - 不可关闭（监管要求：观看前需绑定手机号并上传头像） -->
    <div v-if="profileModalVisible" class="reg-modal">
      <div class="reg-modal-content">
        <div class="reg-modal-header">
          <span class="reg-icon">⚠️</span>
          <span>请先完善个人信息</span>
        </div>
        <div class="reg-modal-body">
          <p>观看视频需要绑定手机号并上传头像</p>
          <p class="reg-tip">请前往电脑端登录后，在"我的资料"中完善信息后再观看</p>
        </div>
        <div class="reg-modal-footer">
          <button class="reg-btn" @click="goBackFn">返 回</button>
        </div>
      </div>
    </div>
    <!-- 需要认证弹窗（监管课程观看前需完成实人认证） -->
    <div v-if="authModalVisible" class="reg-modal">
      <div class="reg-modal-content">
        <div class="reg-modal-header">
          <span class="reg-icon">⚠️</span>
          <span>需要认证才能继续</span>
        </div>
        <div class="reg-modal-body">
          <p>{{ failMessage }}</p>
          <p class="reg-tip">请前往认证</p>
        </div>
        <div class="reg-modal-footer">
          <button class="reg-btn" @click="goAuth">去认证</button>
        </div>
      </div>
    </div>
    <!-- 认证失败弹窗 - 不可关闭 -->
    <div v-if="failModalVisible" class="reg-modal">
      <div class="reg-modal-content">
        <div class="reg-modal-header">
          <span class="reg-icon">⚠️</span>
          <span>认证失败</span>
        </div>
        <div class="reg-modal-body">
          <p>{{ failMessage }}</p>
          <p class="reg-tip">请重新认证</p>
        </div>
        <div class="reg-modal-footer">
          <button class="reg-btn" @click="retryAuth">重新认证</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  name: "detailsList",
  data() {
    return {
      id: '',
      is_join: 1,
      content: '2020二建协议护航班-包过不过退费2020二建协议护航班-包过不过退费2020二建协议护航班-包过不过退费2020二建协议护航班-包过不过退费',
      introduces: {},
      isDisable: false,
      videoImages: true,
      autoplay: false,

      // 视频标签

      playerOptions: {
        playbackRates: [1.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "",
          src: "" //url地址
        }],
        poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true  //全屏按钮
        }
      },

      gklog: 0, //视频观看时长
      last_play_time: 0, // 防快进基准（取自服务端进度或上次正常播放位置）
      duration: '',

      // ===== 视频进度上报相关 =====
      is_viewing: 0,
      change_view_time: 0,
      change_view_seconds: 10,

      // ===== 实人认证相关（监管课程，与PC端流程一致） =====
      uid: 0, // 用户id（checkauth/changeAuth等接口需要）
      isNeedAuth: false,
      defaultAuthType: 'realauth', // realauth=阿里云实人认证 picture=拍照比对
      authSysParam: null, // 用户认证状态 bio
      authSysSetParam: null, // 系统认证配置 real_switch/auth_time
      failModalVisible: false,
      failMessage: '',
      authModalVisible: false,
      profileModalVisible: false,
      authCertifyId: '',
      checkAuthTimer: null,

      // ===== 行为监控 SDK（学习模式） =====
      learningSdk: null,
      learningProxy: null,
      sdkLastTime: 0 // 最近一次播放进度（seek上报的起点）

    }
  },
  async created() {
    const routeParams = this.$route.query;
    this.id = routeParams.id
    let token = JSON.parse(window.localStorage.getItem('jin-token'))
    if (token) {
      // 先校验资料（手机号+头像），再校验实人认证状态，通过后加载视频
      this.checkProfile()
    }

  },
  mounted() {
    // 页面关闭时兜底上报观看状态与播放进度
    window.addEventListener('beforeunload', this.beforeunloadFn)
    // 定时校验实人认证状态（监管课程观看中轮询，与PC端节奏一致）
    this.checkAuthTimer = setInterval(() => {
      // 资料未完善时只显示资料弹窗，不触发认证弹窗
      if (this.profileModalVisible) return
      this.postRequest('api/user/checkauth', {
        uid: this.uid,
        class_id: this.id
      }).then(({ data }) => {
        if (data.code == 1 && data.data.needAuth) {
          this.pauseVideo()
          this.changeAuth('authing')
          this.isNeedAuth = true
          this.showAuthModal('认证已失效，请重新认证')
        }
      }).catch(() => {})
    }, 1000 * 60)
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.beforeunloadFn)
    clearInterval(this.checkAuthTimer)
    document.body.style.overflow = ''
    // 销毁行为监控SDK（自动flush未发送的事件）
    if (this.learningSdk) {
      this.learningSdk.destroy()
      this.learningSdk = null
      this.learningProxy = null
    }
    // SPA内退出页面（点返回箭头/返回手势）不会触发beforeunload，组件销毁时补报最终进度
    if (this.is_viewing) {
      this.change_view_status(0)
    }
    if (this.gklog) {
      this.duration = this.gklog
      this.Recordtheplay()
    }
  },
  methods: {

    /* 获取视频播放进度 */
    onPlayerTimeupdate(player) {
      var current = player.cache_.currentTime
      this.gklog = current
      // 防快进：进度比基准突增超过2秒则回退到基准（基准来自服务端进度，换设备/清缓存同样有效）
      if (this.last_play_time && current - this.last_play_time > 2) {
        player.currentTime(this.last_play_time);
      } else {
        this.last_play_time = current
      }
      // 定时上报观看中状态并同步播放进度（每10秒一次，与PC端节奏一致）
      if (current >= this.change_view_time) {
        this.change_view_status(1)
        this.duration = current
        this.Recordtheplay()
        this.change_view_time += this.change_view_seconds
      }
    },
    onPlayerPlay(player) {
      this.is_viewing = 1
      this.change_view_status(1)
    },
    onplayerPause(player) {
      // console.log(player);
      this.change_view_status(0)
      this.duration = player.cache_.currentTime
      this.Recordtheplay()
    },
    /* 设置视频进度 */
    playerReadied(player) {
      // console.log('我执行了');
      // console.log(this.gklog);
      player.currentTime(this.gklog)
    },
    goBackFn() {  // 回到上一步
      this.$router.go(-1);
    },
    richesHandle(data) {   // 富文本处理
      let fn_result = data
      fn_result = fn_result.replace(/()/g, "");
      fn_result = fn_result.replace(/(&nbsp;)/g, "");
      fn_result = fn_result.replace("<html><head><title></title></head><body>", "");
      fn_result = fn_result.replace("</body></html>", "")
      return fn_result;
    },
    async getIntroduces() {
      let that = this
      try {
        const res = await that.postRequest("api/user/video_detail", {
          id: that.id
        })
        const body = res.data
        // 未认证/资料未完善等后端返回code=0及msg（error返回体无data字段），直接提示
        if (body.code != 1 || !body.data) {
          const msg = body.msg || '加载失败'
          // 认证类错误（未认证/认证过期）直接弹认证弹窗，便于用户立即重新认证，避免只提示后卡住
          if (msg.indexOf('实人认证') !== -1) {
            this.isNeedAuth = true
            this.showAuthModal(msg)
            return
          }
          Toast.fail(msg)
          return
        }
        const data = body.data
        // console.log(data);
        this.playerOptions['sources'][0]['src'] = data.video_file
        this.playerOptions['poster'] = data.video_image
        this.gklog = data.bofangtime
        // 防快进基准 = 服务端记录的上次播放进度，保证下次进入能从该进度继续
        this.last_play_time = data.bofangtime
        // 定时上报起点 = 当前进度 + 10秒
        this.change_view_time = data.bofangtime + this.change_view_seconds
        // console.log(this.playerOptions['sources'][0]['src']);
        that.introduces = data
        that.content = data.content
        that.is_join = data.is_join
        // 创建行为监控 SDK（学习模式）绑定视频（仅监管课程后端会返回session_token）
        if (data.session_token && window.SafetyAuditSDK) {
          this.initLearningSdk(data.session_token)
        }
      } catch (err) {
        // console.log(err);
        Toast.fail((err && err.msg) || '加载失败')
      }
    },

    /* ===== 实人认证与行为监控（对接监管平台，与PC端train.vue流程一致） ===== */

    // 校验是否已绑定手机号并上传头像（拍照比对认证需要头像作为底照）
    checkProfile() {
      this.postRequest('api/user/index').then(({ data }) => {
        if (data.code == 1 && data.data) {
          const u = data.data
          this.uid = u.id
          if (!u.mobile || !u.image) {
            this.profileModalVisible = true
            document.body.style.overflow = 'hidden'
            return
          }
        }
        this.setSysParam()
      }).catch(() => {
        // 接口异常时继续认证校验流程，由后续接口兜底拦截
        this.setSysParam()
      })
    },
    // 获取认证系统参数并校验实人认证状态
    setSysParam() {
      this.postRequest('api/user/authInfo', {
        uid: this.uid,
        class_id: this.id
      }).then(({ data }) => {
        if (data.code != 1) return
        const sysParam = data.data.authset
        const authParam = data.data.auth
        this.authSysSetParam = sysParam
        this.authSysParam = authParam
        // 非监管课程：无需刷脸认证，直接加载视频（后端也不会创建监控会话）
        if (data.data.is_regulate == 0) {
          this.isNeedAuth = false
          this.getIntroduces()
          return
        }
        // 监管课程：按系统配置选择认证方式（1=阿里云实人认证 0=拍照比对）
        this.defaultAuthType = sysParam.real_switch == 1 ? 'realauth' : 'picture'
        if (authParam.bio == 'authsuccess') {
          // 已认证，清理回跳参数后加载视频
          this.clearAuthParams()
          this.isNeedAuth = false
          this.getIntroduces()
        } else if (authParam.bio == 'authing' && this.defaultAuthType == 'realauth') {
          // 阿里云实人认证回跳，校验认证结果
          this.checkAuth()
        } else if (authParam.bio == 'authfail') {
          this.isNeedAuth = true
          this.showFailModal('认证失败，请重新认证')
        } else {
          // 未认证（bio为空或拍照认证中），弹出认证弹窗
          this.isNeedAuth = true
          this.showAuthModal()
        }
      }).catch(() => {})
    },
    // 实人认证 - 跳转阿里云认证页面（real_switch=1时）
    auth() {
      const param = {
        metaInfo: (typeof window.getMetaInfo === 'function') ? window.getMetaInfo() : '',
        returnUrl: window.location.href,
        uid: this.uid
      }
      this.postRequest('api/realauth/getCertify', param).then(({ data }) => {
        if (data.code == 1 && data.data && data.data.certifyUrl) {
          // 跳转阿里云认证页（后端已将认证状态置为authing）
          window.location.href = data.data.certifyUrl
        } else {
          this.showFailModal(data.msg || '获取认证信息失败，请稍后重试')
        }
      }).catch(() => {
        this.showFailModal('获取认证信息失败，请稍后重试')
      })
    },
    // 校验阿里云实人认证结果（从地址栏response参数解析）
    checkAuth() {
      const urlParams = new URLSearchParams(window.location.search)
      const responseStr = urlParams.get('response')
      if (!responseStr) {
        this.showFailModal('未找到认证结果，请重新认证')
        return
      }
      try {
        const responseObj = JSON.parse(decodeURIComponent(responseStr))
        const certifyId = responseObj && responseObj.extInfo ? responseObj.extInfo.certifyId : ''
        this.authCertifyId = certifyId
        if (!certifyId) {
          this.clearAuthParams()
          this.showFailModal('认证结果解析失败，请重新认证')
          return
        }
        this.postRequest('api/realauth/checkCertify', {
          certifyId: certifyId,
          uid: this.uid
        }).then(({ data }) => {
          if (data.code == 1 && data.data && data.data.passed == 'T') {
            Toast.success('认证成功')
            this.clearAuthParams()
            this.isNeedAuth = false
            this.getIntroduces()
          } else {
            this.clearAuthParams()
            this.showFailModal('认证失败，请重新认证')
          }
        }).catch(() => {
          this.showFailModal('认证服务异常，请稍后重试')
        })
      } catch (e) {
        this.showFailModal('认证结果解析失败，请重新认证')
      }
    },
    // 拍照比对认证 - 跳转内部拍照认证页（real_switch=0时）
    pictureDeal() {
      this.$router.push({
        path: '/authCamera',
        query: { page: 'study', uid: String(this.uid), id: this.id }
      })
    },
    // 清除地址栏中的认证回跳参数（replaceState不整页刷新，避免重复创建监控会话）
    clearAuthParams() {
      const urlParams = new URLSearchParams(window.location.search)
      let changed = false
      ;['response', 'picture'].forEach(param => {
        if (urlParams.get(param) !== null) {
          urlParams.delete(param)
          changed = true
        }
      })
      if (!changed) return
      const newUrl = window.location.href.split('?')[0] + (urlParams.toString() ? '?' + urlParams.toString() : '')
      window.history.replaceState({}, '', newUrl)
    },
    showAuthModal(msg) {
      this.failMessage = msg || '监管课程需完成实人认证后才能观看'
      this.authModalVisible = true
      document.body.style.overflow = 'hidden'
    },
    showFailModal(message) {
      this.failMessage = message
      this.failModalVisible = true
      document.body.style.overflow = 'hidden'
    },
    hideFailModal() {
      this.failModalVisible = false
      this.failMessage = ''
      document.body.style.overflow = ''
    },
    // 去认证（按系统配置选择认证方式；认证SDK不可用时回退拍照比对）
    goAuth() {
      if (this.defaultAuthType == 'picture' || typeof window.getMetaInfo !== 'function') {
        this.pictureDeal()
      } else {
        this.auth()
      }
    },
    // 重新认证
    retryAuth() {
      this.hideFailModal()
      this.goAuth()
    },
    // 修改认证状态（进入认证流程时标记authing）
    changeAuth(auth) {
      this.postRequest('api/user/changeAuth', {
        uid: this.uid,
        auth: auth || 'authing'
      }).then(() => {}).catch(() => {})
    },
    pauseVideo() {
      const player = this.$refs.videoPlayer && this.$refs.videoPlayer.player
      if (player) {
        try { player.pause() } catch (e) { /* 忽略暂停异常 */ }
      }
    },

    /* ===== 行为监控 SDK（学习模式） ===== */

    // 创建行为监控 SDK 并通过 proxy 绑定视频播放行为
    initLearningSdk(session_token) {
      if (this.learningSdk) {
        this.learningSdk.destroy()
        this.learningSdk = null
        this.learningProxy = null
      }
      this.learningSdk = new window.SafetyAuditSDK({
        token: session_token,
        mode: 'learning',
        baseURL: 'https://www.agryjxjy.cn',
        debug: false
      })
      // 第三方播放器（video.js）手动触发回调
      this.learningProxy = this.learningSdk.bindVideoProxy()
      this.bindVideoToSdk()
    },
    // 为 video.js 播放器绑定播放行为回调（与PC端一致）
    bindVideoToSdk() {
      // 组件已销毁或SDK已释放时停止重试
      if (this._isDestroyed || !this.learningSdk) return
      let player = this.$refs.videoPlayer && this.$refs.videoPlayer.player
      if (!player || !this.learningProxy) {
        // 播放器尚未就绪，稍后重试
        setTimeout(() => this.bindVideoToSdk(), 1000)
        return
      }
      // 播放 / 暂停 / 进度 / 倍速 / 快进 / 结束
      player.off('play', this.sdkOnPlay)
      player.off('pause', this.sdkOnPause)
      player.off('timeupdate', this.sdkOnTimeUpdate)
      player.off('ratechange', this.sdkOnRateChange)
      player.off('seeking', this.sdkOnSeeking)
      player.off('ended', this.sdkOnEnded)
      player.on('play', this.sdkOnPlay)
      player.on('pause', this.sdkOnPause)
      player.on('timeupdate', this.sdkOnTimeUpdate)
      player.on('ratechange', this.sdkOnRateChange)
      player.on('seeking', this.sdkOnSeeking)
      player.on('ended', this.sdkOnEnded)
    },
    sdkOnPlay() {
      if (this.learningProxy) this.learningProxy.onPlay(this.curTime())
    },
    sdkOnPause() {
      if (this.learningProxy) this.learningProxy.onPause(this.curTime())
    },
    sdkOnTimeUpdate() {
      this.sdkLastTime = this.curTime()
      if (this.learningProxy) this.learningProxy.onTimeUpdate(this.sdkLastTime)
    },
    sdkOnRateChange() {
      const player = this.$refs.videoPlayer && this.$refs.videoPlayer.player
      if (this.learningProxy && player) this.learningProxy.onRateChange(player.playbackRate())
    },
    sdkOnSeeking() {
      // seeking时currentTime即跳转目标位置，起点取最近一次timeupdate的进度
      if (this.learningProxy) this.learningProxy.onSeeked(this.sdkLastTime, this.curTime())
    },
    sdkOnEnded() {
      if (this.learningProxy) this.learningProxy.onEnded()
    },
    curTime() {
      const player = this.$refs.videoPlayer && this.$refs.videoPlayer.player
      return player ? player.currentTime() : 0
    },
    async addPlan() {
      let that = this
      try {
        this.isDisable = true
        const { data } = await that.postRequest("api/user/join", {
          id: that.id
        })
        // console.log(data);
        if (data.code == 1) {
          Toast.success(data.msg)
          this.is_join = 2
          this.isDisable = false
        }
      } catch (err) {
        // console.log(err);
        Toast.fail(err.msg)
        this.isDisable = false
      }
    },
    async Recordtheplay() {
      let that = this
      try {
        const { data } = await that.postRequest("api/user/bofang", {
          id: that.id,
          duration: that.duration
        })
        // console.log(data);
        if (data.code == 1) {
          // Toast.success(data.msg)
        }
      } catch (err) {
        // 播放中每10秒周期性上报，失败时静默处理，避免频繁弹出提示（与PC端一致）
      }
    },
    // 上报观看状态（1=观看中 0=暂停/离开）
    change_view_status(e) {
      this.postRequest('api/user/change_view_status', {
        view_status: e,
        view_id: this.id
      }).then(({ data }) => {})
    },
    // 页面关闭时兜底上报（防止关闭页面导致进度/状态丢失）
    beforeunloadFn() {
      let token = JSON.parse(localStorage.getItem('jin-token')) || ''
      if (this.is_viewing) {
        this.sendBeacon('https://ht.tjjianan.com/api/user/change_view_status', {
          view_status: 0,
          view_id: this.id,
          token: token
        })
      }
      if (this.gklog) {
        this.sendBeacon('https://ht.tjjianan.com/api/user/bofang', {
          id: this.id,
          duration: this.gklog,
          token: token
        })
      }
    },
    // 使用 sendBeacon 发送兜底请求（页面卸载时仍能可靠送达）
    sendBeacon(url, param) {
      if (!navigator.sendBeacon) return
      let data = new FormData()
      for (let key in param) {
        if (param.hasOwnProperty(key)) {
          data.append(key, param[key])
        }
      }
      navigator.sendBeacon(url, data)
    },
    clickImgVideo() {
      this.videoImages = false
      this.openPlay();
      // console.log(this.autoplay);
    },
    openPlay() {
      let that = this
      that.autoplay = true
      this.$forceUpdate()
      // console.log(this.autoplay);
    },
    openPause() {
      this.autoplay = false
    },
  }
}
</script>

<style scoped lang='less'>
.container {
  width: 100%;
  min-height: 100%;
  background-color: #fff;
  position: relative;
  .boxtop {
    .fixedtop {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      background-color: #fff;
      z-index: 10;
    }
  }
  .top__details {
    margin-top: 60px;
    width: 100%;

    .video_box {
      width: 100%;
      height: 211px;
      position: relative;

      .video__mp4 {
        width: 100%;
        height: 211px;
      }

      .video__images {
        width: 100%;
        height: 211px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
      }
    }

    .contest {
      width: 100%;
      padding: 0 16px;
      box-sizing: border-box;

      .title__bxs {
        width: 100%;
        padding: 16px 0px;
        box-sizing: border-box;
        border-bottom: 1px solid #eeeeee;

        .detail__title {
          width: 100%;
          opacity: 1;
          font-size: 18px;
          font-family: PingFangSC-Medium;
          text-align: left;
          color: #06121e;
          font-weight: 600;
        }

        .detai_down {
          width: 100%;
          display: flex;
          align-items: center;
          padding-top: 16px;
          box-sizing: border-box;

          .ont_b {
            // flex: 1;
            padding: 0 17px;
            box-sizing: border-box;
            border-right: 1px solid #b4b1b2;
            opacity: 1;
            font-size: 12px;
            font-family: PingFangSC-Regular;
            text-align: left;
            color: #707070;
            letter-spacing: 0px;

            &:first-child {
              padding: 0 17px 0 0;
            }
            &:last-child {
              padding: 0 0 0 17px;
              border-right: 0 none;
              text-align: right;
            }
          }
        }
      }

      // 内容介绍
      .cont_title {
        padding: 16px 0;
        box-sizing: border-box;
        width: 100%;
        background-color: #fff;
        .contjs {
          font-size: 16px;
          font-family: PingFangSC-Medium;
          text-align: left;
          color: #06121e;
          line-height: 26px;
          font-weight: 600;
          position: relative;
          opacity: 1;

          &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 65px;
            height: 10px;
            background-color: #d7ecff;
            opacity: 0.3;
          }
        }

        .listContent {
          width: 100%;
          margin-top: 16px;
        }
      }
    }

    .but__ton {
      width: 100%;
      position: fixed;
      bottom: 0px;
      left: 0;
      z-index: 10;

      .butt_ox {
        width: 100%;
        height: 52px;

        .jin_button {
          width: 100%;
          height: 52px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 16px;
          background-color: #3e8bff;
        }

        .jin_color {
          background-color: #bdc4ce;
          color: #3e8bff;
        }

        button {
          padding: 0;
          margin: 0;
          border: 0 none;
        }
      }
    }
  }
}

/* ===== 监管认证弹窗 ===== */
.reg-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  .reg-modal-content {
    width: 78%;
    background-color: #fff;
    border-radius: 12px;
    overflow: hidden;

    .reg-modal-header {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px 16px 8px;
      font-size: 17px;
      font-weight: 600;
      color: #ee0a24;

      .reg-icon {
        font-size: 20px;
        margin-right: 6px;
      }
    }

    .reg-modal-body {
      padding: 10px 20px;
      text-align: center;
      color: #333;
      line-height: 1.6;
      font-size: 14px;

      .reg-tip {
        margin-top: 6px;
        font-size: 12px;
        color: #999;
      }
    }

    .reg-modal-footer {
      padding: 14px 20px 20px;

      .reg-btn {
        width: 100%;
        border: none;
        border-radius: 22px;
        padding: 11px 0;
        font-size: 16px;
        background-color: #3e8bff;
        color: #fff;

        &:active {
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
<style>
.listContent img {
  display: block;
  margin: 0 auto;
  max-width: 100% !important;
  height: auto !important;
}

.listContent p {
  max-width: 100%;
  word-break: break-all;
  font-size: 16px !important;
}

.listContent span {
  max-width: 100%;
  word-break: break-all;
  font-size: 16px !important;
}

table {
  max-width: 100%;
}
video {
  max-width: 100% !important;
}
</style>